import { isTypeId, type TypeId, typeid } from "../../utils/typeid.ts";
import type { BaseFile } from "../base-file/base-file.ts";
import { ForbiddenError } from "../error/errors.ts";
import type { GrafitUserId } from "../user/user.ts";

export const FILE_TYPE_ID = "file";

export interface GrafitFile extends BaseFile {
  id: TypeId<typeof FILE_TYPE_ID>;
  uploadedById: GrafitUserId;
}

export const generateFileId = (): GrafitFile["id"] => typeid(FILE_TYPE_ID);

export const isFileId = (id: unknown): id is GrafitFile["id"] => {
  return isTypeId(id, FILE_TYPE_ID);
};

export const buildExcelImportFilePath = (fileId: GrafitFile["id"]): string => {
  return `excel-upload/${fileId}`;
};

export const buildOrganisationFilePath = ({
  organisationId,
  filePath,
}: {
  organisationId: string;
  filePath: string;
}): string => `${organisationId}/${filePath}`;

export function assertFileOwnedByOrganisation(filePath: GrafitFile["path"], organisationId: string): void {
  if (!filePath.startsWith(`${organisationId}/`)) {
    throw new ForbiddenError("File does not belong to this organisation");
  }
}
